import React, { createContext, useState } from "react";
import { apiProduct } from "@Services/API/IndividualApi's/Products";
import { ProductDetail } from "@Components/Pages/ProductDetail";
import Loader from "@Components/Loader";
import {
  productDetailsSkeleton,
  productDetailsSkeletonInMobile,
} from "@Components/Loader/Skeleton";
import { useMediaQuery } from "@mui/material";
import { theme } from "@Definitions/Styled";
import Head from "next/head";
import { Layout } from "@Components/Layout";

export const ProductContext = createContext<any>({});
export default function Page({ productData }: any) {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!productData && loading) {
    return (
      <>
        {isMobile ? (
          <Loader renderSkeleton={productDetailsSkeletonInMobile} />
        ) : (
          <Loader renderSkeleton={productDetailsSkeleton} />
        )}
      </>
    );
  }
  if (errorMessage) {
    return <h1>{errorMessage}</h1>;
  }

  return (
    <>
      <Head>
        <title>{productData.metaData?.title} - Econut</title>
        <meta name="description" content={productData.metaData.description} />
        <meta name="title" content={productData.metaData?.title} />
        <meta
          name="keywords"
          content={productData.metaData?.keywords.toString()}
        />
      </Head>
      <Layout>
        <ProductContext.Provider value={productData}>
          {" "}
          <ProductDetail product={productData!} />
        </ProductContext.Provider>
      </Layout>
    </>
  );
}
export const getServerSideProps = async (context: {
  params: { slug: string };
}) => {
  const data = await apiProduct.getSingleBySlug!(context.params.slug);

  if (!data) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      productData: data,
    }, // will be passed to the page component as props
  };
};
